import { useState, useEffect } from 'react';
import api from '../services/api';

export function useLegalSettings() {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    api.get('/legal-settings')
      .then(res => { if (!cancelled) setSettings(res.data); })
      .catch(err => console.error('Erreur chargement mentions légales :', err))
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  return { settings, loading };
}

// Helper : retourne la valeur ou un placeholder si vide
// formatter (optionnel) : fonction (hint) => string pour personnaliser la sortie (i18n)
export const orPlaceholder = (value, hint, formatter) => {
  if (value && value.trim()) return value;
  if (typeof formatter === 'function') return formatter(hint);
  return `[À compléter : ${hint}]`;
};
